import axios from 'axios';
import { DetailsBooking } from 'types';
import downloadFile, { FileType, Target } from '../utils/downloadFile';
import { throwWrappedAxiosError } from 'lib/errors';

const downloadAppleWalletPass = async (booking: DetailsBooking) => {
  await axios({
    method: 'get',
    url: booking.links.downloadAppleWalletPass,
    responseType: 'blob',
    withCredentials: true,
  })
    .then(({ data }) => downloadFile(`${booking.reference}.pkpass`, data, FileType['application/vnd.apple.pkpass'], Target['_blank']))
    .catch(throwWrappedAxiosError);
};

export default downloadAppleWalletPass;
